module.exports = __webpack_public_path__ + "img/flag-FR.0bb00237.svg";